/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

import { createContext, useContext } from 'react';

import { SESSION_MODES } from './constants';

const EMPTY_SESSION = Object.freeze({
  open: false,
  mode: SESSION_MODES.BLANK,
  attachedItems: [],
  availableItems: [],
  listFilters: null,
});

const EMPTY_DERIVED = Object.freeze({ hasContext: false, attachedCount: 0 });

const noop = () => {};

export const CommandIntelligenceContext = createContext(null);

export const useCommandIntelligence = () => {
  const context = useContext(CommandIntelligenceContext);

  if (!context) {
    return {
      enabled: false,
      session: EMPTY_SESSION,
      derived: EMPTY_DERIVED,
      openBlank: noop,
      openForItem: noop,
      openForItemList: noop,
      updateAvailableItems: noop,
      attachItems: noop,
      detachItem: noop,
      clearAttached: noop,
      close: noop,
      configure: noop,
      clearConfiguration: noop,
    };
  }

  return context;
};
